import { createMuiTheme } from "@material-ui/core";

const defaultTheme = createMuiTheme();

export default {
  root: {
    // [defaultTheme.breakpoints.up("md")]: { minWidth: 360 },
  },
};
